var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-user", { attrs: { containerClass: "bg-white" } }, [
    _c(
      "form",
      {
        attrs: { autocomplete: "off", method: "post", "data-vv-scope": "form" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.reset.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "row mt-2 mt-sm-0 mb-4" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _c("h1", { staticClass: "title text-center text-sm-left" }, [
              _vm._v(_vm._s(this.pageTitle)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-4" }, [
          _c(
            "div",
            { staticClass: "col-sm-12" },
            [
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|email",
                      expression: "'required|email'",
                    },
                  ],
                  staticClass: "city-form-group city-bg form-xl",
                  attrs: {
                    type: "text",
                    id: "input-email",
                    name: "email",
                    inputClasses: [
                      "form-control-xl",
                      {
                        "is-invalid": _vm.$root.fnHasError("form.email", this),
                      },
                    ],
                    error: _vm.errors.first("form.email"),
                    disabled: true,
                  },
                  model: {
                    value: _vm.form.email,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "email",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.email",
                  },
                },
                [_vm._v("Email")]
              ),
              _vm._v(" "),
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required: true,
                        min: _vm.getMinPasswordLength(),
                      },
                      expression:
                        "{required: true, min: getMinPasswordLength()}",
                    },
                  ],
                  ref: "password",
                  staticClass: "city-form-group city-bg form-xl",
                  attrs: {
                    type: "password",
                    id: "input-password",
                    name: "password",
                    inputClasses: [
                      "form-control-xl",
                      {
                        "is-invalid": _vm.$root.fnHasError(
                          "form.password",
                          this
                        ),
                      },
                    ],
                    error: _vm.errors.first("form.password"),
                  },
                  model: {
                    value: _vm.form.password,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "password",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.password",
                  },
                },
                [_vm._v("Nova Password")]
              ),
              _vm._v(" "),
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|confirmed:password",
                      expression: "'required|confirmed:password'",
                    },
                  ],
                  staticClass: "city-form-group city-bg form-xl",
                  attrs: {
                    type: "password",
                    id: "input-confirmPassword",
                    name: "confirmPassword",
                    inputClasses: [
                      "form-control-xl",
                      {
                        "is-invalid": _vm.$root.fnHasError(
                          "form.confirmPassword",
                          this
                        ),
                      },
                    ],
                    error: _vm.errors.first("form.confirmPassword"),
                  },
                  model: {
                    value: _vm.form.confirmPassword,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "confirmPassword",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.confirmPassword",
                  },
                },
                [_vm._v("Confirmar Nova Password")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pt-sm-3" }, [
          _c(
            "div",
            { staticClass: "col-12 col-sm-6 mx-0 order-2 order-sm-1" },
            [
              _c(
                "router-link",
                {
                  staticClass:
                    "btn btn-outline-main btn-rounded btn-lg btn-responsive min-w-auto z-depth-0 btn-block",
                  attrs: { to: { name: "portal.login" } },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t" + _vm._s(this.cancelTitle) + "\n\t\t\t\t\t"
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-sm-6 mx-0 order-1 order-sm-2" },
            [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-main btn-rounded btn-lg btn-responsive min-w-auto z-depth-0 btn-block mb-3 mb-sm-0 text-nowrap",
                  attrs: { type: "submit", disabled: _vm.isDisabled },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t" + _vm._s(this.submitTitle) + "\n\t\t\t\t\t"
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }